import React, {Component} from "react";
import PropTypes from "prop-types";
import classes from 'classnames';
import {withRouter} from 'react-router-dom';
import routerConfig from '../../../config/router';
import {Button, buttonTypes} from "../../../components/Button";

import "./Menu.scss";

class Menu extends Component {
  state = {
    userType: '',
  };

  static propTypes = {
    history: PropTypes.object,
    cart: PropTypes.array,
    user: PropTypes.object,
  };

  componentWillMount(){
    this.setState({userType: this.props.user ? this.props.user.vendorType : ''})
  }

  componentWillReceiveProps(next){
    this.setState({userType: next.user ? next.user.vendorType : ''})
  }

  render() {
    const {
      cart,
      history
    } = this.props;

    const {
      userType
    } = this.state;
    return (
      <ul className="menu">
        <li
          className={classes('menu__item menu__item_home', {active: history.location.pathname === '/'})}
        >
          <Button
            className="ti-home"
            name="Home"
            type={buttonTypes.LINK}
            onClick={() => {
              history.push(routerConfig.home);
            }}
          />
        </li>
        {
          userType && userType === 'tour' ?
            (
              <li
                className={classes('menu__item menu__item_home', {active: history.location.pathname === '/vendor'})}
              >
                <Button
                  className="ti-star"
                  name="My Inventory"
                  type={buttonTypes.LINK}
                  onClick={() => {
                    history.push(routerConfig.vendor.home);
                  }}
                />
              </li>
            ) :
            (
              <li
                className={classes('menu__item menu__item_cart', {active: history.location.pathname === '/cart'})}
              >
                <Button
                  className="ti-shopping-cart"
                  name="Cart"
                  type={buttonTypes.LINK}
                  onClick={() => {
                    history.push(routerConfig.cart);
                  }}
                />
                {
                  cart && cart.length > 0 && <span className="menu__item__notification">{cart.length}</span>
                }
              </li>
            )
        }
      </ul>
    )
  }
}

export default withRouter(Menu);


// WEBPACK FOOTER //
// ./src/app/containers/Header/components/Menu.js